import { Button, Dialog, DialogActions, DialogTitle, InputAdornment, Stack, TextField } from "@mui/material";
import moment from "moment";
import { useState } from "react";

export default function BalanceModal({session, onClose, onSubmit}) {

    const [errors, setErrors] = useState({});


    const handleSubmit = e => {
        e.preventDefault();

        setErrors({});

        const paidAt = e.target.elements['paidAt']?.value;
        const balanceAmount = e.target.elements['balanceAmount']?.value;

        let err = {};

        if (!moment(paidAt).isValid()) err.paidAt = "Date non valide";

        if (isNaN(parseFloat(balanceAmount))) err.balanceAmount = "Montant non valide";

        if (parseFloat(balanceAmount) <= 0) err.balanceAmount = "Montant non valide";

        if (Object.keys(err).length > 0) return setErrors(err);

        let newSession = {...session,
            paidAt: moment(paidAt).format('YYYY-MM-DD'),
            balanceAmount: parseFloat(balanceAmount)
        }

        return onSubmit(newSession);
    }

    return (
        <Dialog onClose={onClose} open={session ? true : false}>

            <DialogTitle>Solde de la session {session?.number}</DialogTitle>

            <form id="dpc_balance" onSubmit={handleSubmit}>

                <Stack sx={{minWidth: 300, mx: 2}} spacing={3}>

                    <TextField
                        label="Session soldée le"
                        name="paidAt"
                        type='date'
                        defaultValue={session?.paidAt || moment().format('YYYY-MM-DD')}
                        size='small'
                        InputLabelProps={{ shrink: true }}
                        error={errors.paidAt ? true : false}
                        helperText={errors.paidAt}
                    />

                    <TextField
                        label='Montant du solde'
                        name="balanceAmount"
                        type='number'
                        size='small'
                        defaultValue={session?.balanceAmount}
                        InputProps={{
                            endAdornment: <InputAdornment position='end'>€</InputAdornment>,
                        }}
                        inputProps={{
                            min: 0,
                            step: 0.01
                        }}
                        required
                    />

                </Stack>

            </form>

            <DialogActions>
                <Button onClick={onClose}>Annuler</Button>
                <Button form="dpc_balance" type="submit">
                    Confirmer
                </Button>
            </DialogActions>

        </Dialog>
    )
}
